import apiService from './apiService'

export default {
  // Récupérer tous les contrats avec filtres et pagination
  async getContrats(page = 1, perPage = 10, filters = {}) {
    try {
      // Remove empty filter values
      const cleanFilters = {};
      for (const key in filters) {
        if (filters[key] !== '' && filters[key] !== null && filters[key] !== undefined) {
          cleanFilters[key] = filters[key];
        }
      }
      
      // Check if we have filters
      const hasActiveFilters = Object.keys(cleanFilters).length > 0;
      
      let endpoint;
      let queryParams;
      
      if (hasActiveFilters) {
        // Use search endpoint if there are filters
        endpoint = '/contrats/search';
        queryParams = new URLSearchParams({
          ...cleanFilters,
          page,
          per_page: perPage
        }).toString();
      } else {
        // Use regular endpoint if no filters
        endpoint = '/contrats';
        queryParams = new URLSearchParams({
          page,
          per_page: perPage
        }).toString();
      }
      
      console.log('Fetching contracts with params:', `${endpoint}?${queryParams}`);
      const response = await apiService.get(`${endpoint}?${queryParams}`);
      console.log('Contracts API response:', response);
      return response;
    } catch (error) {
      console.error('Erreur lors de la récupération des contrats:', error)
      throw error
    }
  },

  // Récupérer un contrat par ID
  async getContratById(id) {
    try {
      const response = await apiService.get(`/contrats/${id}`)
      return response
    } catch (error) {
      console.error('Erreur lors de la récupération du contrat:', error)
      throw error
    }
  },

  // Créer un nouveau contrat
  async createContrat(contratData) {
    try {
      // Check if contratData is FormData (for file uploads) or regular object
      if (contratData instanceof FormData) {
        const response = await apiService.uploadFile('/contrats', contratData)
        return response
      } else {
        const response = await apiService.post('/contrats', contratData)
        return response
      }
    } catch (error) {
      console.error('Erreur lors de la création du contrat:', error)
      throw error
    }
  },

  // Mettre à jour un contrat
  async updateContrat(id, contratData) {
    try {
      const response = await apiService.put(`/contrats/${id}`, contratData)
      return response
    } catch (error) {
      console.error('Erreur lors de la mise à jour du contrat:', error)
      throw error
    }
  },

  // Mettre à jour un contrat avec fichier
  async updateContratWithFile(id, formData) {
    try {
      const response = await apiService.uploadFile(`/contrats/${id}/update-with-file`, formData)
      return response
    } catch (error) {
      console.error('Erreur lors de la mise à jour du contrat avec fichier:', error)
      throw error
    }
  },

  // Supprimer un contrat
  async deleteContrat(id) {
    try {
      const response = await apiService.delete(`/contrats/${id}`)
      return response
    } catch (error) {
      console.error('Erreur lors de la suppression du contrat:', error)
      throw error
    }
  },

  // Télécharger le PDF d'un contrat
  async downloadContratPdf(id) {
    try {
      const response = await apiService.get(`/contrats/${id}/pdf`, {
        responseType: 'blob'
      })
      return response
    } catch (error) {
      console.error('Erreur lors du téléchargement du PDF:', error)
      throw error
    }
  },

  // Uploader un PDF pour un contrat
  async uploadContratPdf(id, file) {
    try {
      const formData = new FormData()
      formData.append('pdf', file)
      
      const response = await apiService.uploadFile(`/contrats/${id}/pdf`, formData)
      return response
    } catch (error) {
      console.error('Erreur lors de l\'upload du PDF:', error)
      throw error
    }
  }
} 